import { ListMenuItem } from "@compass/core";
import { Permission, PermissionAction } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import {
  staffBulkCreateServicesPageRoute,
  StaffBulkCreateServicesPageState,
} from "../StaffBulkCreateServicesPage/StaffBulkCreateServicesPage";

export const useStaffListMenuItems = (props: { permission: Permission; selectedIds: number[] }) => {
  const navigate = useNavigate();
  const menuItems: ListMenuItem[] = [];

  if (isAuthorized(Permission.StaffService, PermissionAction.Create))
    menuItems.push({
      label: "+ New Services",
      action: (selectedIds: number[]) =>
        navigate(staffBulkCreateServicesPageRoute.getPath(), {
          state: { selectedIds: selectedIds } as StaffBulkCreateServicesPageState,
        }),
    });

  // if (isAuthorized(props.permission, PermissionAction.Update)) {
  //   menuItems.push({
  //     label: "Merge",
  //     action: (selectedIds: number[]) =>
  //       navigate(staffBulkMergePageRoute.getPath(), {
  //         state: { selectedIds: selectedIds } as StaffBulkMergePageState,
  //       }),
  //     disabled: props.selectedIds.length < 2,
  //   });
  // }

  return menuItems;
};
